import { RoomRequest } from '@shared/models/hotel-search-payload.model';
import { ROOMS_LOCAL_STORAGE_KEY, ROOM_SEQ_NR, TRAVEL_HOTEL_SEARCH_LOCAL_STORAGE_KEY } from 'app.config';
import * as CryptoJS from 'crypto-js';

export function calculateNumOfGuests(roomRequests: RoomRequest[]): number {
  return roomRequests.reduce((a, b) => (a += b.num_adults + b.num_infants + b.children_ages.length), 0);
}

export function getHash(hotelId: number) {
  const travelHotelSearchCriteria = (localStorage.getItem(TRAVEL_HOTEL_SEARCH_LOCAL_STORAGE_KEY) || '') + hotelId;
  const hash = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(travelHotelSearchCriteria));
  return hash.toString(CryptoJS.enc.Hex);
}

export function clearLocalSelectedRooms() {
  Object.keys(sessionStorage).forEach((key: string) => {
    if (key.includes(ROOMS_LOCAL_STORAGE_KEY)) {
      sessionStorage.removeItem(key);
    }
    if (key.includes(ROOM_SEQ_NR)) {
      sessionStorage.removeItem(key);
    }
  });
}
